import { render, staticRenderFns } from "./EventCalendarCard.vue?vue&type=template&id=a4b7772a&"
import script from "./EventCalendarCard.vue?vue&type=script&lang=js&"
export * from "./EventCalendarCard.vue?vue&type=script&lang=js&"
import style0 from "./EventCalendarCard.vue?vue&type=style&index=0&id=a4b7772a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports